import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  adjustRetailStock,
  fetchRetailStock,
  type AdjustStockPayload,
  type ListRetailStockQuery,
} from '@/services/api/retailStock.api';

export function useRetailStock(query: ListRetailStockQuery, enabled = true) {
  return useQuery({
    queryKey: ['retail-stock', query],
    queryFn: () => fetchRetailStock(query),
    staleTime: 30_000,
    enabled: enabled && !!query.propertyId,
  });
}

export function useAdjustStock() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: AdjustStockPayload) => adjustRetailStock(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['retail-stock'] });
      void queryClient.invalidateQueries({ queryKey: ['retail-products'] });
    },
  });
}
